document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("shipping-policy-checkbox");
  const checkoutBtn = document.querySelector(
    'button.cart__checkout-button[name="checkout"]'
  );

  if (!checkbox || !checkoutBtn) return;

  /* Added 2026-10-22: the button was disabled whenever this box was unticked,
     with nothing on screen saying so. Customers picked a method and a date,
     saw a dead grey button, and left. Styled by .date-validation-message,
     which already exists in main-cart-footer.liquid. */
  let policyError = document.getElementById("policy-error");
  if (!policyError) {
    policyError = document.createElement("p");
    policyError.id = "policy-error";
    policyError.className = "date-validation-message";
    policyError.textContent =
      "Please tick the box above to agree to the Shipping Policy before checking out.";
    const wrap =
      checkbox.closest(".cart-policy-confirmation") || checkbox.parentElement;
    wrap.appendChild(policyError);
  }

  /* Only prompt once they are actually in the flow, so a fresh cart page does
     not greet them with red text. */
  function hasEngaged() {
    const method = document.querySelector('input[name="shipping-method"]:checked');
    const dateField = document.getElementById("delivery-date");
    return !!method || !!(dateField && dateField.value);
  }

  function updateState() {
    const enabled = checkbox.checked;
    checkoutBtn.disabled = !enabled;
    checkoutBtn.style.opacity = enabled ? "1" : "0.5";
    checkoutBtn.style.pointerEvents = enabled ? "auto" : "none";
    policyError.classList.toggle("show", !enabled && hasEngaged());
  }

  updateState();
  checkbox.addEventListener("change", updateState);

  document
    .querySelectorAll('input[name="shipping-method"]')
    .forEach(function (r) { r.addEventListener("change", updateState); });
  const dateField = document.getElementById("delivery-date");
  if (dateField) {
    dateField.addEventListener("change", updateState);
    dateField.addEventListener("input", updateState);
  }
});

/* The two blocks that used to follow here were dead code: they targeted
   #shipping-agreement-checkbox and button#checkout, neither of which exists on
   the cart page (the real buttons are #openModalBtn2 and #openModalBtn).
   Removed 2026-10-22. The commented-out DS cleanup block above them was also
   already inert and has been removed with them. */
